import type {AfriexGroupedProcessorMetrics} from '@afriex/core/domain/types';

import {Accordion} from '@/components';

import SubCurrencyTable from './Processor/SubCurrencyTable';

const CurrencyAccordion = ({
  data: groupedByCurrency,
}: {
  data: AfriexGroupedProcessorMetrics;
}) => {
  return (
    <div>
      {Object.keys(groupedByCurrency).map((currency) => (
        <Accordion
          key={currency}
          title={`Currency: ${currency}`}
          headerStyle="bg-gray-200 dark:bg-gray-800 shadow-sm py-1.5"
        >
          <SubCurrencyTable data={groupedByCurrency} currency={currency} />
        </Accordion>
      ))}
    </div>
  );
};

export default CurrencyAccordion;
